exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center {\n  margin: auto;\n  width: 60%;\n  border: 3px solid rgba(138, 138, 132, 0.89);\n  padding: 10px; }\n\n.customer-logo img {\n  max-width: 60%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/join-via-creditupclub/join-via-creditupclub.component.scss
// module id = ../../../../../src/app/join-via-creditupclub/join-via-creditupclub.component.scss
// module chunks = main